/// <reference path="../../../../../rcwebmodels/usermessagesui.cs.d.ts" />
import * as React from 'react';
import $ from 'jquery';
import { RCUtils } from './../../RCUtils';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import DateFormat from 'dateformat';

var Config: any = require('../../Config.json');


interface CommentsState {
    SelectedReefers: any[];
    UserComments: server.UserMessageBoardData;
    RowData: server.UserMessagesUI[];
    SelectedReefer: string;
    UnitMasterId: any;
    MessageBoardId: any;
    commandUnits: server.ReeferCommandUnits[];
    DeleteMessage: string;
    DeleteParams: any;
    assetMasterID: number;//WI-23781
}

var defaultUserComments: server.UserMessageBoardData = {
    MessageBoardID: 0, UserID: 0, Message: '', CreatedDTTM: null, AssetMasterID: 0
};
var self;
export class Comments extends React.Component<any, CommentsState> {
    constructor(props: any) {
        super(props);
        self = this;
        this.state = {
            SelectedReefers: [], UserComments: defaultUserComments, RowData: [], SelectedReefer: '', commandUnits: [], DeleteMessage: '',
            DeleteParams: null, UnitMasterId: 0, MessageBoardId: null, assetMasterID: 0
        };
    }

    componentDidMount() {
        var reeferData = this.props.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.ReeferID != null) {
            this.setState({ RowData: [], SelectedReefers: reeferData, SelectedReefer: reeferData.ReeferID, UnitMasterId: reeferData.UnitMasterID, assetMasterID: this.props.AssetMasterID });
            if (reeferData.UnitMasterID != undefined && reeferData.UnitMasterID != null) {
                this.GetCommentsData(reeferData, this.props.AssetMasterID);//WI-23781
            }
        }
        else {
            this.setState({ RowData: [], SelectedReefers: reeferData, SelectedReefer: reeferData.ReeferID, UnitMasterId: reeferData.AssetMasterID, assetMasterID: this.props.AssetMasterID });
            if (reeferData.AssetMasterID != undefined && reeferData.AssetMasterID != null) {
                this.GetCommentsData(reeferData, this.props.AssetMasterID);//WI-23781
            }

        }

        this.performShowhidebuttons(false);
    }

    componentWillReceiveProps(nextProps: any) {
        var reeferData = nextProps.reeferData;
        if (reeferData != undefined && reeferData != null && reeferData.ReeferID != null) {
            this.setState({ RowData: [], SelectedReefers: reeferData, SelectedReefer: reeferData.ReeferID, UnitMasterId: reeferData.AssetMasterID, assetMasterID: nextProps.AssetMasterID });
            if (nextProps.AssetMasterID != undefined && nextProps.AssetMasterID != null) {
                this.GetCommentsData(reeferData, nextProps.AssetMasterID);
            }
        }
        else {
            this.setState({ RowData: [], SelectedReefers: reeferData, SelectedReefer: reeferData.AssetNumber, UnitMasterId: reeferData.AssetMasterID, assetMasterID: nextProps.AssetMasterID });
            if (nextProps.AssetMasterID != undefined && nextProps.AssetMasterID != null) {
                this.GetCommentsData(reeferData, nextProps.AssetMasterID);
            }

        }
    }

    dateTimeConverter(dttmValue) {
        if (dttmValue == "" || dttmValue == null) {
            return '-NA-';
        }
        else {
            var timeZoneOffset = JSON.parse(sessionStorage.getItem('UserInfo')).TimeZoneOffSet;
            var eventdttm = new Date(dttmValue);
            var prefDateTime = new Date(eventdttm.getTime() + (parseInt(timeZoneOffset) * 60000));
            return DateFormat(prefDateTime, 'mm/dd/yyyy h:MM:ss TT');
        }
    }

    closeModel() {
        $('#CommentModal').hide();
        $('#deleteCommentModal').hide();
        $('#deleteAllCommentModal').hide();
    }

    public AddComment(): void {
        if (this.state.SelectedReefer != undefined) {
            $('#AddComment').addClass('active');
            $('#RefreshComment').removeClass('active');
            $('#DeleteAll').removeClass('active');
            $('#CommentModal').show();
        }
    }

    public RefreshComment(): void {
        if (this.state.SelectedReefer != undefined) {
            $('#globalLoader').show();
            $('#AddComment').removeClass('active');
            $('#RefreshComment').addClass('active');
            $('#DeleteAll').removeClass('active');
            this.RefreshCommentsData(this.state.SelectedReefers, this.props.AssetMasterID);
        }
    }

    public DeleteAll(): void {
        if (this.state.SelectedReefer != undefined) {
            $('#AddComment').removeClass('active');
            $('#RefreshComment').removeClass('active');
            $('#DeleteAll').addClass('active');
            this.setState({ DeleteMessage: '' });
            this.GetCommentsDataForDeleteAll(this.state.SelectedReefers, this.props.AssetMasterID);
        }
    }

    public GetCommentsDataForDeleteAll(reeferData: any, AssetMasterID: number): void {
        /* WI-23781
        var unitMasterID;
        if (reeferData.UnitMasterID != undefined) {
            unitMasterID = reeferData.UnitMasterID;
        }
        var url = Config.ApiBaseUrl + '/api/Comments/GetComments?UnitMasterId=' + unitMasterID;
        */
        var url = Config.ApiBaseUrl + '/api/Comments/GetComments?AssetMasterID=' + AssetMasterID;
        var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.UserMessagesUI[]>)
            .then(data => {
                if (data.length > 0) {
                    this.setState({ DeleteMessage: 'Are you sure you want to delete All Comments?' });
                    this.performShowhidebuttons(false);
                }
                else {
                    this.setState({ DeleteMessage: 'There are no comments to delete.' });
                    this.performShowhidebuttons(true);
                }

                $('#deleteAllCommentModal').show();
                this.setState({ RowData: data });
                $('#globalLoader').hide();
            });
    }

    performYesActionDeleteAll(params: any) {
        this.deleteAllComments();
        this.closeModel();
    }

    deleteAllComments() {
        $('#globalLoader').show();
        var url = Config.ApiBaseUrl + '/api/Comments/DeleteAllComments?AssetMasterID=' + this.props.AssetMasterID;
        var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                $('#globalLoader').hide();
                PopupWindow.showErrorMessage("Delete All Comments", data);
                this.GetCommentsData(this.state.SelectedReefers, this.props.AssetMasterID);
            });
    }

    performNoActionDeleteAll() {
        $('#deleteAllCommentModal').hide();
    }

    performYesAction(params: any) {
        var par = this.state.MessageBoardId;
        this.deleteComment(par);
        this.closeModel();
    }

    deleteComment(params: any) {
        $('#globalLoader').show();
        var url = Config.ApiBaseUrl + '/api/Comments/DeleteComments?MessageBoardId=' + params;
        var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        fetch(request)
            .then(RCUtils.handleError)
            .then(response => response.json())
            .then(data => {
                $('#globalLoader').hide();
                PopupWindow.showErrorMessage("Delete Comment", data);
                this.GetCommentsData(this.state.SelectedReefers, this.props.AssetMasterID);
            });
    }

    performNoAction() {
        this.closeModel();
    }

    performShowhidebuttons(isOkvisible) {
        if (isOkvisible) {
            $("#btnYes").hide();
            $("#btnNo").hide();
            $("#btnOk").show();
        }
        else {
            $("#btnYes").show();
            $("#btnNo").show();
            $("#btnOk").hide();
        }
    }

    dateDiffrence(date: any) {
        var stLatest = "";
        if (date) {
            var today = new Date();
            var past = new Date(date);
            var diff = Math.floor(today.getTime() - past.getTime());
            var day = 1000 * 60 * 60 * 24;
            var days = Math.floor(diff / day);
            if (days < 1) {
                stLatest = "[Latest]";
            } else {
                stLatest = "";
            }
        }

        return stLatest;
    }

    SaveAction() {
        $('#globalLoader').show();
        var userComments: server.UserMessageBoardData = JSON.parse(JSON.stringify(this.state.UserComments));
        if ((this.state.UserComments != null && this.state.UserComments.Message.trim() == "")) {
            PopupWindow.showErrorMessage("Comments", "Please enter comments.");
            $('#globalLoader').hide();
            return;
        }
        else {
            userComments.AssetMasterID = this.props.AssetMasterID;//this.state.UnitMasterId;
            userComments.CreatedDTTM = new Date();
            var url = Config.ApiBaseUrl + '/api/Comments/SaveComments';
            var request = RCUtils.FetchRequest(url, { method: 'POST', body: JSON.stringify(userComments), headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json())
                .then(data => {
                    $('#globalLoader').hide();
                    PopupWindow.showErrorMessage("Add Comment", data);
                    var userComments: server.UserMessageBoardData = JSON.parse(JSON.stringify(this.state.UserComments));
                    userComments.Message = '';
                    this.setState({ UserComments: userComments });
                    this.GetCommentsData(this.state.SelectedReefers, this.props.AssetMasterID);
                });
        }

        this.closeModel();
    }

    public MessageOnChange(event: any): void {
        const name = event.target.name;
        const value = event.target.value;
        var userComments: server.UserMessageBoardData = JSON.parse(JSON.stringify(this.state.UserComments));
        userComments.Message = value;
        this.setState({ UserComments: userComments });
    }

    removeComment(commentId: any) {
        this.setState({ MessageBoardId: commentId, DeleteMessage: 'Are you sure you want to delete this Comment?' }, () => { $('#deleteCommentModal').show(); });
    }

    CancelAction() {
        $('#CommentModal').hide();
    }

    public GetCommentsData(reeferData: any, AssetMasterID: number): void {
        /*
        WI-23781
        var unitMasterID;
        if (reeferData.UnitMasterID != undefined) {
            unitMasterID =  reeferData.AssetMasterID;
        }
        var url = Config.ApiBaseUrl + '/api/Comments/GetComments?UnitMasterId=' + unitMasterID;
        */
        var url = Config.ApiBaseUrl + '/api/Comments/GetComments?AssetMasterID=' + AssetMasterID;

        var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.UserMessagesUI[]>)
            .then(data => {
                this.setState({ RowData: data });
            });
    }
    public RefreshCommentsData(reeferData: any, AssetMasterID: number): void {
        /* WI-23781
        var unitMasterID;
        if (reeferData.UnitMasterID != undefined) {
            unitMasterID = reeferData.UnitMasterID;
        }
        var url = Config.ApiBaseUrl + '/api/Comments/GetComments?UnitMasterId=' + unitMasterID;
        */
        var url = Config.ApiBaseUrl + '/api/Comments/GetComments?AssetMasterID=' + AssetMasterID;
        var request = RCUtils.FetchRequest(url, { method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' } });
        RCUtils.fetchFaultRetry(request)
            .then(RCUtils.handleResponse)
            .then(response => response.json() as Promise<server.UserMessagesUI[]>)
            .then(data => {
                $('#globalLoader').hide();
                this.setState({ RowData: data });
            });
    }

    public render() {
        return (
            <div>
                {this.LoadCommentsData()}
            </div>
        );
    }

    LoadCommentsData() {
        var self = this, commentsList = this.state.RowData;
        var commentsList = this.state.RowData;
        return (<div>
            <div className="modal" role="dialog" id="deleteAllCommentModal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Delete Comments</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={this.closeModel.bind(this)}><span aria-hidden="true">&times;</span></button>                            
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert alert-info" role="alert">
                                        <span className="glyphicon glyphicon-question-sign" aria-hidden="true"></span>
                                        <div className='alert-text'>
                                            {this.state.DeleteMessage}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                          
                            <button type="button" id="btnNo" className="btn btn-secondary" onClick={this.performNoActionDeleteAll.bind(this)}>No</button>
                            <button type="button" id="btnOk" className="btn btn-secondary" onClick={this.performNoActionDeleteAll.bind(this)}>OK</button>
                            <button type="button" id="btnYes" className="btn btn-primary" onClick={this.performYesActionDeleteAll.bind(this)} >Yes</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal" role="dialog" id="deleteCommentModal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Delete Comments</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={this.closeModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                           
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert alert-info" role="alert">
                                        <span className="glyphicon glyphicon-info-sign font-size-20 float-start" aria-hidden="true"></span>
                                        <div className="alert-text">
                                            {this.state.DeleteMessage}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.performNoAction.bind(this)}>No</button>
                            <button type="button" className="btn btn-primary" onClick={this.performYesAction.bind(this)} >Yes</button>
                            
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal" role="dialog" id="CommentModal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Comments</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={this.closeModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                           
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <textarea className='form-control' value={this.state.UserComments.Message} onChange={this.MessageOnChange.bind(this)} rows={6} maxLength={4000} placeholder="Comments" id="exampleFormControlTextarea2"></textarea>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={this.CancelAction.bind(this)}>Cancel</button>
                            <button type="button" className="btn btn-primary" onClick={this.SaveAction.bind(this)} >Save</button>
                           
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <div className="accordion-item accordion-item rounded-0 rounded-bottom">
                   
                        <h4 className="accordion-header" role="tab" id="headingThree">
                            <button className="accordion-button accordion-item rounded-0 rounded-bottom collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="true" aria-controls="panelsStayOpen-collapseThree">
                                Comments

                                <div className='btn-group btn-group-sm btn-group-dsd ms-auto'>
                                    <button type="button" id="AddComment" name="AddComment" onClick={() => this.AddComment()} className="btn btn-outline-secondary"><span className='fa-solid fa-plus'></span></button>
                                    <button type="button" id="RefreshComment" name="RefreshComment" onClick={() => this.RefreshComment()} className="btn btn-outline-secondary"><span className='fa-sharp fa-solid fa-arrows-rotate'></span></button>
                                    <button type="button" id="DeleteAll" name="DeleteAll" onClick={() => this.DeleteAll()} className="btn btn-outline-secondary">Remove All Comments</button>
                                </div>

                            </button>
                        </h4>
                  
                    <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse">
                        <div className="accordion-body">
                            <ul className="list-group">
                                {Object.keys(commentsList).map(function (comment) {
                                    var formattedDate = self.dateTimeConverter(commentsList[comment].CreatedDTTM);
                                    var latestStr = self.dateDiffrence(formattedDate);
                                    return (
                                        <li className="list-group-item" key={comment}>
                                            <div className='reefer-details-commnents'>
                                                <h1 className="name">{commentsList[comment].Message}</h1>
                                                <p className="type">{commentsList[comment].Username} Posted on {formattedDate}  {latestStr}</p>
                                                <button type="button" className="btn btn-primary" onClick={() => self.removeComment(commentsList[comment].MessageBoardID)} ><span className='fa-solid fa-trash'></span></button>
                                            </div>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>)
    }
}